/**
 * Created by Carsten Bühler
 * User: CBuehler on 01.04.2016
 * Copyright: xdot GmbH 2015
 */


'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { Col, Row } from 'external/react-bootstrap';
import TimeLineItem from './TimeLineItem';
import TimeLineItemMessageHeader from './TimeLineItemMessageHeader';
import BusinessObjectLink from '../BusinessObjectLink';
import { translation } from 'plugin/liferay-widgets-react-web';

const GeoFeatureChangeRecordRenderer = ({ changeRecord, userMeta }) => {

    return (<TimeLineItem userMeta={userMeta} timestamp={changeRecord.timestamp}>
            <TimeLineItemMessageHeader>
                <strong>
                    Positionsänderung für{' '}
                    { translation.trans(changeRecord.className)+' '}<BusinessObjectLink className={changeRecord.attachedClassName}
                                        classPK={changeRecord.attachedClassPK}/>{' '}
                </strong>
                <br/>

                    <Row>
                        {changeRecord.changes.geometry &&
                        <Col xs={12}>
                            <p>
                                {/*Position-Alt: { changeRecord.changes.geometry.oldValue }<br/>
                                Position-Neu: { changeRecord.changes.geometry.newValue }<br/>*/
                                    changeRecord.changes.geometry.newValue ? 'Position wurde geändert!' : ''}
                            </p>
                        </Col>
                        }
                        {changeRecord.changes.properties &&
                        <Col xs={12}>
                            <p>
                                Eigenschaften-Alt: {changeRecord.changes.properties.oldValue}<br/>
                                Eigenschaften-Neu: {changeRecord.changes.properties.newValue}<br/>
                            </p>
                        </Col>
                        }
                        {changeRecord.changes.geometryType &&
                        <Col xs={12}>
                            <p>
                                Typ-Alt: {changeRecord.changes.geometryType.oldValue}<br/>
                                Typ-Neu: {changeRecord.changes.geometryType.newValue}<br/>
                            </p>
                        </Col>
                        }
                    </Row>

            </TimeLineItemMessageHeader>
        </TimeLineItem>

    );
};

GeoFeatureChangeRecordRenderer.propTypes = {
    item: PropTypes.object,
    changeRecord: PropTypes.object,
    userMeta: PropTypes.object
};

export default GeoFeatureChangeRecordRenderer;





// WEBPACK FOOTER //
// ./js/components/ChangeRecords/GeoFeatureChangeRecordRenderer.jsx